import comp from "./PusherSubscribeHoc";
export default comp;
